//
// forms/js-email-prefill-form.js
//
// An open email field that either:
// a) dummy-submits, saving the entered email as prefill data
//    and then simply redirecting elsewhere.
// b) takes the value of the open email field and inserts it into the email field of
//    a form with matching form id that is present on the same page.
//
// Note: mode a) is triggered by setting 'redirect' to a value other than null

import submission from './submission';

function dummy_submit_and_redirect(email_field) {
  const controller = submission(email_field);

  controller.register__submit(form => JSON.stringify({}));   // Dummy submit

  const btn = email_field.querySelector('.c-btn');

  email_field.addEventListener('Form/BeginSubmission', () => {
    btn.classList.remove('c-btn--standing');
    btn.classList.add('c-btn--loading');
  });

  email_field.addEventListener('Form/CancelSubmission', () => {
    btn.classList.remove('c-btn--standing');
    btn.classList.remove('c-btn--loading');
    btn.classList.add('c-btn--error');
  });
}

function prefill_same_page_form(email_field, same_page_form) {
  const btn                        = email_field.querySelector('.c-btn');
  const input                      = email_field.querySelector('.c-input');
  const same_page_form_email_field = same_page_form.querySelector('input[type="email"]');

  btn.addEventListener('click', () => {
    same_page_form_email_field.value = input.value;
    setTimeout(() => {
      same_page_form_email_field.focus();
      same_page_form.dispatchEvent(new CustomEvent('Form/LooseValidate'));
    }, 1300); // Magic number - seems to work ok
  })
}

function init(email_field) {
  if (!email_field.hasAttribute('data-redirect') && email_field.hasAttribute('data-form-id')) {
    const same_page_form_id = email_field.getAttribute('data-form-id');
    const same_page_form    = document.querySelector('form[data-form-id="' + same_page_form_id + '"]');

    prefill_same_page_form(email_field, same_page_form);
  }
  else {
    dummy_submit_and_redirect(email_field);
  }
}

function init_all() {
  const email_fields = Array.from(document.getElementsByClassName('js-email-prefill-form'));
  email_fields.forEach(init);
}
init_all();
